import Password from "../components/profile/Password";
import VerifyEmail from "../components/profile/EmailVerify";
import {
  ExpandableSection,
  Container,
} from "@cloudscape-design/components-themed";

const Profile = (): JSX.Element => {
  return (
    <Container>
      <ExpandableSection headerText="パスワード変更">
        <Password />
      </ExpandableSection>
      <ExpandableSection headerText="メールアドレス検証">
        <VerifyEmail />
      </ExpandableSection>
    </Container>
  );
};

export default Profile;
